module.exports = __webpack_public_path__ + "img/Eduzz-10-es.7b3afd9d.png";